import { useEffect } from 'react'
import Shepherd from 'shepherd.js'
import 'shepherd.js/dist/css/shepherd.css'
import './style.css'
import { useDispatch } from 'react-redux'
import { setRiskScoreTour, setRiskScoreTourForInput } from 'src/actions/index'
import { STEP_IDS } from 'src/utils/constants/TourConstants'

const RiskScoreInputTour = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const tour = new Shepherd.Tour({
      useModalOverlay: true,
      disableInteraction: true,
      exitOnEsc: false,
      defaultStepOptions: {
        attachTo: {
          element: '.RiskScoreTourStep1',
          on: 'bottom',
        },
        scrollTo: true,
        cancelIcon: {
          enabled: true,
        },
      },
    })

    tour?.addStep({
      id: STEP_IDS?.STEP_1,
      title: '<div><b>Welcome to the Trovity Dashboard</b><div>',
      text: '<div id="tour-step-text">Let\'s have a quick tour of the application. Click next to continue.</div>',
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      attachTo: {
        element: '#null',
        on: 'left',
      },

      buttons: [
        {
          text: 'Next',
          classes: 'nextButton',
          action: tour?.next,
        },
      ],
    })

    tour?.addStep({
      id: STEP_IDS?.STEP_2,
      title: '<div><b>Check Your Risk Score</b><div>',

      text: '<div id="tour-step-text">This score is calculated for Life, Health, and accident. Covering for these risks ensures a risk-free life.</div>',
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      attachTo: {
        element: '#riskScore',
        on: 'left',
      },
      popperOptions: {
        modifiers: [
          {
            name: 'RiskScoreTour',
            options: {
              element: '#riskScore',
              classes: 'custom-overlay',
            },
          },
          {
            name: 'padding',
            options: {
              padding: 50,
            },
          },
        ],
      },
      buttons: [
        {
          text: 'Back',
          classes: 'backButton',
          action: tour?.back,
        },
        {
          text: 'Next',
          classes: 'nextButton',
          action: () => {
            tour?.next()
          },
        },
      ],
    })

    tour?.addStep({
      id: STEP_IDS?.STEP_3,
      title: '<div><b>Enter Salary Details</b><div>',

      text: '<div id="tour-step-text">Enter your Annual Salary to calculate Risk Score and click on the arrow button to show your Risk Score.</div>',
      scrollTo: {
        behavior: 'smooth',
        block: 'center',
      },
      attachTo: {
        element: '#totalCtcTextField',
        on: 'bottom-start',
      },
      popperOptions: {
        modifiers: [
          {
            name: 'RiskScoreTour',
            options: {
              element: '#riskScore',
              classes: 'custom-overlay',
            },
          },
          {
            name: 'padding',
            options: {
              padding: 50,
            },
          },
        ],
      },
    })

    const handleTourComplete = () => {
      dispatch(setRiskScoreTourForInput(false))
      dispatch(setRiskScoreTour(true))
    }

    tour?.on('complete', handleTourComplete)

    tour?.start()

    return () => {
      tour?.complete(() => {})
    }
  }, [dispatch])

  return null
}

export default RiskScoreInputTour
